<template>
  <div>
    <div
      class="shape"
      :class="[color, `shape--${alignment}`, { ' shape--xcenter': xCenter }, additionalClass]"
    >
      <Component
        :is="getSvg()"
        class="icon shape__svg"
        :class="svgClass"
        :preserveAspectRatio="preserveAspectRatio"
      />
    </div>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
  path: {
    type: String,
    default: 'waveOne',
  },
  color: {
    type: String,
    default: 'text-primary-100',
  },
  additionalClass: {
    type: String,
    default: '',
  },
  svgClass: {
    type: String,
    default: '',
  },
  alignment: {
    type: String,
    default: 'bottom',
  },
  xCenter: {
    type: Boolean,
    default: true,
  },
  preserveAspectRatio: {
    type: String,
    default: 'xMidYMax',
    validator(value) {
      return ['xMidYMax', 'xMidYMin'].includes(value)
    },
  },
})

const getSvg = () => {
  switch (props.path) {
    case 'waveOne': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveOneSvg.vue'))
    }
    case 'waveTwo': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveTwoSvg.vue'))
    }
    case 'waveThree': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveThreeSvg.vue'))
    }
    case 'waveFour': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveFourSvg.vue'))
    }
    case 'waveFive': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveFiveSvg.vue'))
    }
    case 'waveBottom': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveBottomSvg.vue'))
    }
    case 'headerMobile': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/HeaderMobileSvg.vue'))
    }
    case 'navbarSecondary': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/NavbarSecondarySvg.vue'))
    }
    case 'footer': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/FooterSvg.vue'))
    }
    case 'footerMobile': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/FooterMobileSvg.vue'))
    }
    case 'line': {
      return defineAsyncComponent(() => import('@/components/svg/shapes/LineSvg.vue'))
    }
    default: {
      console.log('Missing wave SVG', props.path)
      return defineAsyncComponent(() => import('@/components/svg/shapes/WaveOneSvg.vue'))
    }
  }
}
</script>
